/**
 * Stable machine codes for every rule violation the rulebook can emit.
 *
 * These end up in API responses and Sentry fingerprints: rename a value only
 * with a deliberate migration, never as a drive-by cleanup.
 */
export const RULE_CODES = {
  // Company identity
  COMPANY_NAME_REQUIRED: "COMPANY_NAME_REQUIRED",
  COMPANY_NAME_TOO_LONG: "COMPANY_NAME_TOO_LONG",
  COMPANY_NAME_INVALID: "COMPANY_NAME_INVALID",
  COMPANY_TYPE_INVALID: "COMPANY_TYPE_INVALID",

  // Formation
  FORMATION_STATE_REQUIRED: "FORMATION_STATE_REQUIRED",
  FORMATION_STATE_UNSUPPORTED: "FORMATION_STATE_UNSUPPORTED",
  FORMATION_STATE_INVALID: "FORMATION_STATE_INVALID",
  FORMATION_DATE_REQUIRED: "FORMATION_DATE_REQUIRED",
  FORMATION_DATE_INVALID: "FORMATION_DATE_INVALID",

  // EIN
  EIN_REQUIRED: "EIN_REQUIRED",
  EIN_INVALID: "EIN_INVALID",

  // C-Corp share structure
  TOTAL_SHARES_INVALID: "TOTAL_SHARES_INVALID",
  RESERVED_EQUITY_INVALID: "RESERVED_EQUITY_INVALID",
  CCORP_SHARES_EXCEED_AVAILABLE: "CCORP_SHARES_EXCEED_AVAILABLE",

  // Shareholder collection
  SHAREHOLDERS_REQUIRED: "SHAREHOLDERS_REQUIRED",
  SHAREHOLDERS_MAX_EXCEEDED: "SHAREHOLDERS_MAX_EXCEEDED",
  SIGNING_AUTHORITY_REQUIRED: "SIGNING_AUTHORITY_REQUIRED",
  LLC_OWNERSHIP_TOTAL_INVALID: "LLC_OWNERSHIP_TOTAL_INVALID",

  // Individual shareholder
  SHAREHOLDER_TYPE_INVALID: "SHAREHOLDER_TYPE_INVALID",
  SHAREHOLDER_NAME_REQUIRED: "SHAREHOLDER_NAME_REQUIRED",
  SHAREHOLDER_NAME_INVALID: "SHAREHOLDER_NAME_INVALID",
  SHAREHOLDER_COMPANY_NAME_INVALID: "SHAREHOLDER_COMPANY_NAME_INVALID",
  SHAREHOLDER_EMAIL_REQUIRED: "SHAREHOLDER_EMAIL_REQUIRED",
  SHAREHOLDER_EMAIL_INVALID: "SHAREHOLDER_EMAIL_INVALID",
  SHAREHOLDER_EMAIL_DUPLICATE: "SHAREHOLDER_EMAIL_DUPLICATE",
  SHAREHOLDER_PHONE_INVALID: "SHAREHOLDER_PHONE_INVALID",
  SHAREHOLDER_TAX_ID_REQUIRED: "SHAREHOLDER_TAX_ID_REQUIRED",
  SHAREHOLDER_TAX_ID_TYPE_INVALID: "SHAREHOLDER_TAX_ID_TYPE_INVALID",
  SHAREHOLDER_TAX_ID_INVALID: "SHAREHOLDER_TAX_ID_INVALID",
  SHAREHOLDER_TAX_ID_DUPLICATE: "SHAREHOLDER_TAX_ID_DUPLICATE",
  SHAREHOLDER_OWNERSHIP_REQUIRED: "SHAREHOLDER_OWNERSHIP_REQUIRED",
  SHAREHOLDER_OWNERSHIP_INVALID: "SHAREHOLDER_OWNERSHIP_INVALID",
  SHAREHOLDER_SHARES_REQUIRED: "SHAREHOLDER_SHARES_REQUIRED",
  SHAREHOLDER_SHARES_INVALID: "SHAREHOLDER_SHARES_INVALID",

  // C-Corp roles
  CCORP_BOARD_MEMBER_REQUIRED: "CCORP_BOARD_MEMBER_REQUIRED",
  CCORP_OFFICER_REQUIRED: "CCORP_OFFICER_REQUIRED",
  CCORP_SECRETARY_REQUIRED: "CCORP_SECRETARY_REQUIRED",
  CCORP_DIRECTOR_NATURAL_PERSON_REQUIRED:
    "CCORP_DIRECTOR_NATURAL_PERSON_REQUIRED",

  // Addresses
  ADDRESSES_REQUIRED: "ADDRESSES_REQUIRED",
  ADDRESS_PRIMARY_REQUIRED: "ADDRESS_PRIMARY_REQUIRED",
  ADDRESS_MAILING_DUPLICATE: "ADDRESS_MAILING_DUPLICATE",
  ADDRESS_TYPE_INVALID: "ADDRESS_TYPE_INVALID",
  ADDRESS_STREET_REQUIRED: "ADDRESS_STREET_REQUIRED",
  ADDRESS_STREET_INVALID: "ADDRESS_STREET_INVALID",
  ADDRESS_CITY_REQUIRED: "ADDRESS_CITY_REQUIRED",
  ADDRESS_STATE_REQUIRED: "ADDRESS_STATE_REQUIRED",
  ADDRESS_STATE_INVALID: "ADDRESS_STATE_INVALID",
  ADDRESS_ZIP_REQUIRED: "ADDRESS_ZIP_REQUIRED",
  ADDRESS_ZIP_INVALID: "ADDRESS_ZIP_INVALID",
  ADDRESS_COUNTRY_REQUIRED: "ADDRESS_COUNTRY_REQUIRED",
} as const;

export type RuleCode = (typeof RULE_CODES)[keyof typeof RULE_CODES];
